import { InvoiceRow, InvoiceStatus } from "@wingspanhq/wingspan-api-sdk";

const DEPOSITED_STATUSES: InvoiceStatus[] = [
  InvoiceStatus.PAID,
  InvoiceStatus.PARTIALLY_PAID,
  InvoiceStatus.PAID_OFF_PLATFORM
];

/**
 * Whether the invoice's funds have been captured (payer paid) — the gate for
 * the refund action. Reads the SDK's raw `InvoiceStatus` directly.
 */
export const selectorIsInvoiceDeposited = (invoice: InvoiceRow) =>
  !!invoice.status && DEPOSITED_STATUSES.includes(invoice.status);
